import Axios from '../../../_helpers/axiosHelper';
import {IReferentials} from "../reducers";

export const getReferentials = (): Promise<IReferentials> => Axios.get(`/referentials`);
